// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsWordIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#41A5EE"
      d="M21.15 3H7.5a.85.85 0 0 0-.85.84v3.74l7.9 2.3L22 7.57V3.84a.85.85 0 0 0-.85-.84"
    />
    <path fill="#2B7CD3" d="M22 7.58H6.65v4.59l7.9 1.37L22 12.17z" />
    <path fill="#185ABD" d="M6.65 12.17v4.58l7.44.92 7.91-.92v-4.58z" />
    <path
      fill="#103F91"
      d="M7.5 21.33h13.65c.47 0 .85-.37.85-.84v-3.74H6.65v3.74c0 .47.38.84.85.84"
    />
    <path
      fill="#000"
      d="M12.31 6.67H6.65v11.45h5.66c.47 0 .85-.37.85-.84V7.51a.85.85 0 0 0-.85-.84"
      opacity={0.1}
    />
    <path
      fill="#000"
      d="M11.85 7.12h-5.2v11.46h5.2c.47 0 .85-.37.85-.84V7.97a.85.85 0 0 0-.85-.85"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M11.85 7.12h-5.2v10.55h5.2c.47 0 .85-.38.85-.84V7.97a.85.85 0 0 0-.85-.85"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M11.38 7.12H6.65v10.55h4.73c.47 0 .85-.38.85-.84V7.97a.85.85 0 0 0-.85-.85"
      opacity={0.2}
    />
    <path
      fill="url(#ms-word_svga)"
      d="M2.85 7.12h8.53c.47 0 .85.38.85.85v8.4c0 .46-.38.84-.85.84H2.85a.85.85 0 0 1-.85-.84v-8.4c0-.47.38-.85.85-.85"
    />
    <path
      fill="#fff"
      d="m5.5 13.57.03.34h.02a4 4 0 0 1 .11-.66l.9-3.81h1.16l.93 3.75q.09.35.11.7h.02q.03-.33.1-.68l.74-3.78h1.05l-1.3 5.47H8.14l-.89-3.62-.14-.77h-.02l-.13.78-.83 3.6H4.87l-1.3-5.45h1.07l.8 3.82z"
    />
    <defs>
      <linearGradient
        id="ms-word_svga"
        x1={3.78}
        x2={10.31}
        y1={6.47}
        y2={17.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2368C4" />
        <stop offset={0.5} stopColor="#1A5DBE" />
        <stop offset={1} stopColor="#1146AC" />
      </linearGradient>
    </defs>
  </svg>,
  "MsWord",
);
export default MsWordIcon;
